import React from 'react';
import { Icon } from 'antd';
import classNames from 'classnames';

const SPECIAL_CHARACTER = '~`!@#$%^&*()\\-_=+\\[\\]{};:\'",.<>/?|';

const RULES = [
  { id: 'length', label: 'At least 6 characters', test: (v) => v.length >= 6 },
  { id: 'lower', label: 'Lowercase letter (a–z)', test: (v) => /[a-z]/.test(v) },
  { id: 'upper', label: 'Uppercase letter (A–Z)', test: (v) => /[A-Z]/.test(v) },
  { id: 'number', label: 'Number (0–9)', test: (v) => /[0-9]/.test(v) },
  {
    id: 'special',
    label: 'Special character',
    test: (v) => new RegExp(`[${SPECIAL_CHARACTER}]`).test(v),
  },
];

export default function PasswordRequirements({ password = '' }) {
  const value = String(password);

  return (
    <div className="onboarding-registration-password-requirements" aria-live="polite">
      <p className="onboarding-registration-password-requirements-title">
        <Icon type="lock" /> Password must include:
      </p>
      <ul>
        {RULES.map((rule) => {
          const met = value.length > 0 && rule.test(value);
          return (
            <li
              key={rule.id}
              className={classNames({ met, pending: value.length > 0 && !met })}
            >
              <Icon type={met ? 'check-circle' : 'minus-circle'} />
              {rule.label}
            </li>
          );
        })}
      </ul>
    </div>
  );
}
